import { instance, GETREQUESTOPTIONS } from "../apiService";

export const getMachineFavorites = async () => {
    const res = await instance.get(
        '/api/room-overview/favorites',
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const isMachineFavorited = async (machineId: string) => {
    const res = await instance.get(
        `/api/room-overview/favorites/is-favorited/${machineId}`,
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const addMachineFavorite = async (machineId: string) => {
    const res = await instance.post(
        '/api/room-overview/favorites/add',
        { machineId },
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const deleteMachineFavorite = async (machineId: string) => {
    const res = await instance.post(
        '/api/room-overview/favorites/delete',
        { machineId },
        GETREQUESTOPTIONS()
    );
    return res.data;
};